import {
  utils,
} from '@ama-sdk/core';
import {
  AcknowledgeRequest,
  Order,
} from '@dapi/sdk';
import {
  createAmount,
  createOrder,
  createOrderAirItem,
  MockOrder,
  RecursivePartial,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  acknowledegedOrderEligibilitiesForTwoBoundDisrupted,
  arnEwrAirPrices,
  arnEwrBaggageAllowanceItems,
  arnEwrBaggageAllowanceItemsForTwoPax,
  arnEwrBound,
  arnEwrFlightItem,
  arnEwrPaymentTransactions,
  arnEwrTravelerDocuments,
  boundId1,
  boundId2,
  cancelAndRefundOrderEligibilities,
  childTraveler,
  contacts,
  cphLhrOslBound,
  cphLhrOslBoundScheduleChange,
  cphOslAcknowledgedBound,
  cphOslBound,
  cphOslBoundInvoluntaryRefundEligible,
  cphOslFlight,
  cphOslFlightItem,
  cphOslScheduleChangeBound,
  cplOshReturnBaggageAllowanceItems,
  creditCardpaymentTransactions,
  fareInfo,
  fareInfoRoundTrip,
  femaleTraveler,
  frequentFlyerCard,
  frequentFlyerCard2,
  helTkuAcknowledgedBound,
  helTkuBound,
  helTkuFlight,
  helTkuFlightItem,
  milesPaymentTransactionsWithoutCancellation,
  milesRefundOrderEligibilities,
  mockMilesAirPrice,
  mockMilesAirPriceForTwoPassengers,
  mockMilesAirPriceWithoutCancellation,
  multiBoundRebookingPrice,
  multiCurrencyAirPricingRecords,
  multiCurrencyAirPricingRecordsForTwoBoundFlight,
  multipleTaxesForCard,
  multipleTaxesForCard2,
  multipleVoucherTransaction,
  multipleVoucherWithCCTransaction,
  nonEligibilityReasonCode201,
  nonEligibilityReasonCode65211,
  orderEligibilitiesForBothBoundsAcknowledged,
  orderEligibilitiesForBoundWithInvolutaryRefundEligibleUsingAmop,
  orderEligibilitiesForBoundWithScheduleChange,
  orderEligibilitiesForMultiBoundDisruption,
  orderEligibilitiesForRoundTripBothBoundWithScheduleChange,
  orderEligibilitiesForRoundTripOneBoundDisrupted,
  orderEligibilitiesForRoundTripOneBoundWithScheduleChange,
  orderEligibilitiesForSingleBoundsAcknowledged,
  orderEligibilitiesForSingleBoundsAcknowledgedChangeAllowed,
  orderEligibilitiesForSingleBoundsAcknowledgedChangeAllowedForObFee,
  orderEligibilitiesForSingleBoundSisterCity,
  orderEligibilitiesForSisterCityTwoBounds,
  orderEligibilitiesForTwoBoundDisruption,
  orderEligibilitiesForTwoBoundDisruptionNotEligibleForChange,
  orderEligibilitiesForTwoBoundDisruptionOneBoundAcknowledgedNotEligibleForChange,
  orderEligibilitiesForTwoBoundsWhenFirstIsAcknowledged,
  orderEligibilitiesSingleBoundIsDisrupted,
  oslCphAcknowledgedBound,
  oslCphAcknowledgedCityChangeBound,
  oslCphBound,
  oslCphDisruptedBound,
  oslCphDisruptedCityChangeBound,
  oslCphFlight,
  oslCphFlightItem,
  oslCphNonDisruptedBound,
  oslCphScheduleChangeBound,
  oslCphUnOnlyFlightItemDifferentFlightId,
  oslLhrBound,
  oslLhrFlightItem,
  outBoundDisruptedObFeePrice,
  paymentCard,
  paypalPaymentTransactions,
  serviceItem,
  tkuHelAcknowledgedBound,
  tkuHelBound,
  tkuHelDisruptedBound,
  tkuHelFlight,
  tkuHelFlightItem,
  traveler,
  traveler2,
  traveler3,
  travelerDocument,
  travelerDocumentsForMilesRefund,
  travelerDocumentsForMilesRefundWithoutCancellation,
  travelerDocumentsForMilesRefundWithTwoPax,
  unOneWayOrderEligibilities,
  unOnlyBound,
  unOnlyBoundFixedDate,
  unOnlyReturnBound,
  voucherPaymentTransactions,
  zeroPriceWithTaxes,
} from '../dictionaries';
import {
  contactEmail,
  contactPhone,
  contactsForOneTraveler,
  contactsForTwoTravelers,
  notificationContactEmail,
  notificationContactPhone,
} from './../dictionaries/contacts';

const unOnlyTemplate: RecursivePartial<Order> = {
  id: 'UM8VXN',
  creationPointOfSale: {
    pointOfSaleId: 'NCE0E08AA',
    countryCode: 'FR'
  },
  creationDateTime: new utils.DateTime('2023-06-20T08:45:00.000Z'),
  lastModificationDateTime: new utils.DateTime('2023-06-20T08:49:00.000Z'),
  isGroupBooking: false,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [unOnlyBound],
      freeCheckedBaggageAllowanceItems: [cplOshReturnBaggageAllowanceItems[0]],
      fareInfos: [{
        fareClass: 'YIFE',
        travelerIds: [traveler.id],
        flightIds: [cphOslFlightItem.id]
      }]
    }
  }),
  travelers: [traveler],
  travelDocuments: [{
    flightIds: [cphOslFlightItem.id],
    travelerIds: [traveler.id],
    id: '1052467303580',
    documentType: 'eticket',
    price: zeroPriceWithTaxes,
    paymentTransactions: [{
      paymentMethod: paymentCard,
      amount: createAmount({
        template: {
          value: 31_720
        }
      }),
      authorization: {
        approvalCode: 'APS1OK'
      }
    }],
    fareInfos: [fareInfo]
  }],
  orderEligibilities: unOneWayOrderEligibilities
};

const orderForUnOnlyRoundTripTemplate: RecursivePartial<Order> = {
  ...unOnlyTemplate,
  id: 'UMC5NH',
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [unOnlyBound, unOnlyReturnBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'YIFE',
        travelerIds: [traveler.id],
        flightIds: [cphOslFlightItem.id, oslCphFlightItem.id]
      }]
    }
  })
};

const orderEligibleToRefundTemplate: RecursivePartial<Order> = {
  id: 'Q3EAEY',
  creationPointOfSale: {
    pointOfSaleId: 'STOSK08VR',
    countryCode: 'SE'
  },
  creationDateTime: new utils.DateTime(todayPlusNdays('08:17', -1)),
  lastModificationDateTime: new utils.DateTime(todayPlusNdays('11:47', -1)),
  isGroupBooking: false,
  air: {
    prices: arnEwrAirPrices,
    bounds: [arnEwrBound],
    freeCheckedBaggageAllowanceItems: arnEwrBaggageAllowanceItems
  },
  travelers: [traveler, traveler2, traveler3],
  contacts: [contactPhone, contactEmail],
  travelDocuments: arnEwrTravelerDocuments,
  paymentRecords: [
    {
      id: 'FPT6',
      paymentTransactions: arnEwrPaymentTransactions,
      travelerIds: [traveler3.id],
      flightIds: [arnEwrFlightItem.id]
    },
    {
      id: 'FPT25',
      paymentTransactions: arnEwrPaymentTransactions,
      travelerIds: [traveler.id, traveler2.id],
      flightIds: [arnEwrFlightItem.id]
    }
  ]
};

export const orderForUnOneWayOnly = createOrder({
  template: unOnlyTemplate
});
export const orderForUnOnlyRoundTrip = createOrder({
  template: orderForUnOnlyRoundTripTemplate
});
export const orderForMultiPaxOneWay: MockOrder = {
  ...orderForUnOneWayOnly,
  contacts: [
    {
      ...contactPhone,
      id: 'OT7'
    },
    {
      ...contactPhone,
      id: 'OT9'
    },
    {
      ...notificationContactPhone,
      id: 'OT10',
      travelerIds: [traveler.id, 'TRAVELER-2-MOCK', 'TRAVELER-1-MOCK']
    },
    {
      ...notificationContactPhone,
      id: 'OT12'
    },
    {
      ...contactEmail,
      id: 'OT8'
    },
    {
      ...contactEmail,
      id: 'OT11'
    },
    {
      ...notificationContactEmail,
      id: 'OT13',
      travelerIds: [traveler.id, 'TRAVELER-2-MOCK', 'TRAVELER-1-MOCK']
    }
  ],
  travelDocuments: [travelerDocument,
    {
      ...travelerDocument,
      id: '6072160342329',
      travelerIds: ['TRAVELER-1-MOCK']
    },
    {
      ...travelerDocument,
      id: '6072160342330',
      travelerIds: ['TRAVELER-2-MOCK']
    }],
  orderEligibilities: cancelAndRefundOrderEligibilities,
  travelers: [
    {
      ...traveler,
      id: traveler.id
    },
    {
      ...femaleTraveler,
      id: 'TRAVELER-1-MOCK'
    },
    {
      ...childTraveler,
      passengerTypeCode: 'CHD',
      id: 'TRAVELER-2-MOCK'
    }]
};

export const orderForUnOnlyOnewayChangeNotEligible: MockOrder = {
  ...orderForUnOneWayOnly,
  orderEligibilities: {
    ...unOneWayOrderEligibilities,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false,
          nonEligibilityReasons: [nonEligibilityReasonCode201]
        }
      ],
      change: [{
        airBoundId: boundId1,
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode65211]
      }]
    }
  }
};

export const orderForCityChange: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [oslCphDisruptedCityChangeBound],
      fareInfos: [{
        fareClass: 'YIFE',
        travelerIds: [traveler.id],
        flightIds: [oslCphFlightItem.id]
      }]
    }
  }),
  orderEligibilities: {
    ...orderEligibilitiesSingleBoundIsDisrupted,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ],
      change: [{
        airBoundId: boundId1,
        isEligible: true
      }]
    }
  }
};

export const orderForCityChangeAcknowledged: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [oslCphAcknowledgedCityChangeBound],
      fareInfos: [{
        fareClass: 'YIFE',
        travelerIds: [traveler.id],
        flightIds: [oslCphFlightItem.id]
      }]
    }
  }),
  orderEligibilities: orderEligibilitiesForSingleBoundsAcknowledged
};

export const orderForMultiPaxOneWayWithFixedDate: MockOrder = {
  ...orderForMultiPaxOneWay,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [unOnlyBoundFixedDate],
      freeCheckedBaggageAllowanceItems: [cplOshReturnBaggageAllowanceItems[0]],
      fareInfos: [{
        fareClass: 'YIFE',
        travelerIds: [traveler.id],
        flightIds: [cphOslFlightItem.id]
      }]
    }
  })
};

export const orderMockEligibleToRefundUsingAmop: MockOrder = {
  ...orderForUnOneWayOnly,
  contacts: [contactPhone, contactEmail],
  travelDocuments: [travelerDocument],
  orderEligibilities: cancelAndRefundOrderEligibilities,
  travelers: [{
    ...traveler,
    id: traveler.id
  }],
  paymentRecords: [
    {
      id: 'FP15',
      paymentTransactions: paypalPaymentTransactions,
      travelerIds: [traveler.id],
      flightIds: [cphOslFlightItem.id]
    }
  ]
};

export const orderMockEligibleToRefundUsingVoucher: MockOrder = {
  ...orderForUnOneWayOnly,
  contacts: [contactPhone, contactEmail],
  travelDocuments: [travelerDocument],
  orderEligibilities: cancelAndRefundOrderEligibilities,
  travelers: [traveler],
  paymentRecords: [
    {
      id: 'FP15',
      paymentTransactions: voucherPaymentTransactions,
      travelerIds: [traveler.id],
      flightIds: [cphOslFlightItem.id]
    }
  ]
};

export const orderMockEligibleToRefundUsingMultipleVouchers: MockOrder = {
  ...orderForUnOneWayOnly,
  contacts: [contactPhone, contactEmail],
  travelDocuments: [travelerDocument],
  orderEligibilities: cancelAndRefundOrderEligibilities,
  travelers: [traveler],
  paymentRecords: [
    {
      id: 'FP15',
      paymentTransactions: multipleVoucherTransaction,
      travelerIds: [traveler.id],
      flightIds: [cphOslFlightItem.id]
    }
  ]
};

export const orderMockEligibleToRefundUsingMultipleVouchersAndCC: MockOrder = {
  ...orderForUnOneWayOnly,
  contacts: [contactPhone, contactEmail],
  travelDocuments: [travelerDocument],
  orderEligibilities: cancelAndRefundOrderEligibilities,
  travelers: [traveler],
  paymentRecords: [
    {
      id: 'FP15',
      paymentTransactions: multipleVoucherWithCCTransaction,
      travelerIds: [traveler.id],
      flightIds: [cphOslFlightItem.id]
    }
  ]
};

export const orderForUnOnlyRoundTripTemplateWithoutContactEmail: MockOrder = {
  ...orderForMultiPaxOneWay,
  contacts: [contactPhone, contactEmail]
};

/**
 * Mocks with Order with two disrupted bounds
 */
export const retrieveOrderMockDisruptedMultiBounds: RecursivePartial<Order> = {
  id: 'TC59QW',
  creationPointOfSale: {
    pointOfSaleId: 'HELAY08MO',
    countryCode: 'FI'
  },
  creationDateTime: new utils.DateTime(),
  lastModificationDateTime: new utils.DateTime(),
  isGroupBooking: false,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [helTkuBound, tkuHelBound]
    }
  }),
  services: [
    {
      id: 'TSM30',
      descriptions: [
        {
          type: 'shortText',
          content: 'WEAP'
        },
        {
          type: 'longText',
          content: 'WEAPON HANDLING FEE'
        }
      ],
      quantity: 2,
      flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
      details: [{
        flightId: helTkuFlightItem.id,
        quantity: 1
      }, {
        flightId: tkuHelFlightItem.id,
        quantity: 1
      }]
    },
    {
      id: 'OT49',
      descriptions: [{
        type: 'shortText',
        content: 'COLA'
      }],
      quantity: 1,
      flightIds: [helTkuFlightItem.id]
    },
    {
      id: 'OT50',
      descriptions: [{
        type: 'shortText',
        content: 'COLA'
      }],
      quantity: 1,
      flightIds: [helTkuFlightItem.id]
    },
    {
      id: 'TSM51',
      descriptions: [{
        type: 'shortText',
        content: 'TRML'
      }],
      quantity: 1,
      flightIds: [helTkuFlightItem.id]
    },
    {
      id: 'OT51',
      descriptions: [{
        type: 'shortText',
        content: 'ABAG'
      }],
      quantity: 1,
      flightIds: [helTkuFlightItem.id]
    }
  ],
  seats: [
    {
      id: 'seat1',
      flightId: helTkuFlightItem.id,
      seatSelections: [{
        seatCharacteristics: [{
          code: 'CH'
        }]
      }]
    },
    {
      id: 'seat2',
      flightId: tkuHelFlightItem.id,
      seatSelections: [{
        seatCharacteristics: [{
          code: 'E'
        }]
      }]
    }
  ],
  travelers: [traveler, childTraveler],
  contacts: [contactPhone],
  travelDocuments: [
    {
      flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
      travelerIds: [traveler.id],
      id: '1052467303584',
      documentType: 'eticket',
      price: multiBoundRebookingPrice,
      paymentTransactions: [{
        paymentMethod: paymentCard
      }],
      fareInfos: [
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: helTkuFlight
        },
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: tkuHelFlight
        }
      ]
    },
    {
      flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
      travelerIds: [childTraveler.id],
      id: '1052467303583',
      documentType: 'eticket',
      price: multiBoundRebookingPrice,
      paymentTransactions: [{
        paymentMethod: paymentCard
      }],
      fareInfos: [
        {
          fareClass: 'YPR0FI/CH',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: helTkuFlight
        },
        {
          fareClass: 'YPR0FI/CH',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: tkuHelFlight
        }
      ]
    }
  ],
  specialServiceRequests: [{
    id: 'OT3',
    code: 'CHLD',
    airlineCode: 'AY',
    statusCode: 'HK',
    quantity: 1,
    freetext: '05APR16',
    travelerIds: [childTraveler.id]
  }],
  orderEligibilities: orderEligibilitiesForMultiBoundDisruption
};
export const orderForDisruptedMultiBounds = createOrder({
  template: retrieveOrderMockDisruptedMultiBounds
});

export const orderForMultiDisruptedBounds: MockOrder = {
  ...orderForDisruptedMultiBounds,
  orderEligibilities: orderEligibilitiesForTwoBoundDisruptionNotEligibleForChange
};

export const orderForMultipleBoundAcknowledged: MockOrder = {
  ...orderForMultiDisruptedBounds,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [helTkuAcknowledgedBound, tkuHelAcknowledgedBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
        travelerIds: [traveler.id, childTraveler.id]
      }]
    }
  }),
  orderEligibilities: acknowledegedOrderEligibilitiesForTwoBoundDisrupted
};

export const orderForMultipleBoundHelToTkuAcknowledged: MockOrder = {
  ...orderForMultiDisruptedBounds,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [helTkuAcknowledgedBound, tkuHelDisruptedBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
        travelerIds: [traveler.id, childTraveler.id]
      }]
    }
  }),
  orderEligibilities: orderEligibilitiesForTwoBoundDisruptionOneBoundAcknowledgedNotEligibleForChange
};

/**
 * CPH OSL return trip order with both bounds disrupted
 */
export const orderWithBothBoundsDisruptedTemplate: RecursivePartial<Order> = {
  id: 'JPGAN6',
  creationPointOfSale: {
    pointOfSaleId: 'NCE0E08AA',
    countryCode: 'FR',
    country: 'FRANCE'
  },
  creationDateTime: new utils.DateTime(),
  contacts,
  lastModificationDateTime: new utils.DateTime(),
  isGroupBooking: false,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecordsForTwoBoundFlight,
      bounds: [cphOslBound, oslCphBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [cphOslFlightItem.id, oslCphFlightItem.id],
        travelerIds: [traveler.id]
      }]
    }
  }),
  travelers: [traveler],
  travelDocuments: [
    {
      areCouponsAndSegmentsInSync: true,
      creation: {
        triggerEventName: 'issuance',
        localDateTime: new utils.DateTime()
      },
      flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
      travelerIds: [traveler.id],
      id: '1052467303584',
      documentType: 'eticket',
      status: 'ISSUED',
      price: multiBoundRebookingPrice,
      paymentTransactions: [{
        paymentMethod: paymentCard
      }],
      fareInfos: [
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: oslCphFlight
        },
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: cphOslFlight
        }
      ]
    }
  ],
  orderEligibilities: orderEligibilitiesForTwoBoundDisruption
};
export const orderWithBothBoundsDisrupted = createOrder({
  template: orderWithBothBoundsDisruptedTemplate
});

/**
 * Order when one bound is confirmed and one is disrupted
 */
export const orderWithReturnBoundDisruptedTemplate: RecursivePartial<Order> = {
  id: 'JPGAN6',
  creationPointOfSale: {
    pointOfSaleId: 'NCE0E08AA',
    countryCode: 'FR',
    country: 'FRANCE'
  },
  creationDateTime: new utils.DateTime(),
  contacts,
  lastModificationDateTime: new utils.DateTime(),
  isGroupBooking: false,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecordsForTwoBoundFlight,
      bounds: [cphOslAcknowledgedBound, oslCphBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [cphOslFlightItem.id, oslCphFlightItem.id],
        travelerIds: [traveler.id]
      }]
    }
  }),
  travelers: [traveler],
  travelDocuments: [
    {
      areCouponsAndSegmentsInSync: true,
      creation: {
        triggerEventName: 'issuance',
        localDateTime: new utils.DateTime()
      },
      flightIds: [helTkuFlightItem.id, tkuHelFlightItem.id],
      travelerIds: [traveler.id],
      id: '1052467303584',
      documentType: 'eticket',
      status: 'ISSUED',
      price: multiBoundRebookingPrice,
      paymentTransactions: [{
        paymentMethod: paymentCard
      }],
      fareInfos: [
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: oslCphFlight
        },
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: cphOslFlight
        }
      ]
    }
  ],
  orderEligibilities: orderEligibilitiesForTwoBoundsWhenFirstIsAcknowledged
};
export const orderWithReturnBoundDisrupted = createOrder({
  template: orderWithReturnBoundDisruptedTemplate
});

/**
 * Order when one bound (OSL-CPH) is disrupted
 */
export const orderForSingleBoundDisruptedTemplate: RecursivePartial<Order> = {
  id: 'JPGAN6',
  creationPointOfSale: {
    pointOfSaleId: 'NCE0E08AA',
    countryCode: 'FR',
    country: 'FRANCE'
  },
  creationDateTime: new utils.DateTime(),
  contacts,
  lastModificationDateTime: new utils.DateTime(),
  isGroupBooking: false,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [oslCphDisruptedBound], // check with oslCphBound
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [oslCphUnOnlyFlightItemDifferentFlightId.id],
        travelerIds: [traveler.id]
      }]
    }
  }),
  travelers: [traveler],
  travelDocuments: [
    {
      areCouponsAndSegmentsInSync: true,
      creation: {
        triggerEventName: 'issuance',
        localDateTime: new utils.DateTime()
      },
      flightIds: [oslCphFlightItem.id],
      travelerIds: [traveler.id],
      id: '1052467303584',
      documentType: 'eticket',
      status: 'ISSUED',
      price: multiBoundRebookingPrice,
      paymentTransactions: [{
        paymentMethod: paymentCard
      }],
      fareInfos: [
        {
          fareClass: 'YPR0FI',
          fareFamilyCode: 'PRO',
          couponStatus: 'open',
          flight: oslCphFlight
        }
      ]
    }
  ],
  orderEligibilities: orderEligibilitiesSingleBoundIsDisrupted
};
export const orderForSingleBoundDisrupted = createOrder({
  template: orderForSingleBoundDisruptedTemplate
});

export const orderForSingleBoundAcknowledged: MockOrder = {
  ...orderForSingleBoundDisrupted,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [oslCphAcknowledgedBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [oslCphFlightItem.id],
        travelerIds: [traveler.id]
      }]
    }
  }),
  orderEligibilities: orderEligibilitiesForSingleBoundsAcknowledged
};

export const retrieveOrderMockDisruptedOutbound: MockOrder = {
  ...orderForSingleBoundDisrupted,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecords,
      bounds: [
        helTkuBound,
        {
          ...tkuHelBound,
          flights: [{
            ...tkuHelFlightItem,
            statusCode: 'HK',
            id: 'ST2'
          }],
          id: 'ST2',
          disruptionStatus: undefined
        }
      ],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [oslCphFlightItem.id],
        travelerIds: [traveler.id]
      }]
    }
  }),
  travelers: [traveler, traveler2],
  orderEligibilities: orderEligibilitiesForSingleBoundsAcknowledgedChangeAllowedForObFee,
  travelDocuments: [{
    flightIds: ['ST2', 'ST3'],
    travelerIds: [traveler.id],
    id: '1052467303580',
    documentType: 'eticket',
    price: outBoundDisruptedObFeePrice,
    paymentTransactions: creditCardpaymentTransactions,
    fareInfos: fareInfoRoundTrip
  }, {
    flightIds: ['ST2', 'ST3'],
    travelerIds: [traveler2.id],
    id: '1052467303579',
    documentType: 'eticket',
    price: outBoundDisruptedObFeePrice,
    paymentTransactions: creditCardpaymentTransactions,
    fareInfos: [
      {
        fareClass: 'YPR0FI',
        fareFamilyCode: 'PRO',
        couponStatus: 'open',
        flight: helTkuFlight
      },
      {
        fareClass: 'YPR0FI',
        fareFamilyCode: 'PRO',
        couponStatus: 'open',
        flight: tkuHelFlight
      }
    ]
  }],
  specialServiceRequests: [
    {
      id: 'OT3',
      code: 'CHLD',
      airlineCode: 'AY',
      statusCode: 'HK',
      quantity: 1,
      freetext: '05APR16',
      travelerIds: [traveler2.id]
    }
  ],
  paymentRecords: [
    {
      id: 'FP15',
      paymentTransactions: creditCardpaymentTransactions,
      travelerIds: [traveler.id],
      flightIds: [oslLhrFlightItem.id]
    },
    {
      id: 'FP17',
      paymentTransactions: creditCardpaymentTransactions,
      travelerIds: [traveler2.id],
      flightIds: [oslLhrFlightItem.id]
    }
  ]
};

export const orderForSingleBoundAcknowledgedChangeAllowed: MockOrder = {
  ...orderForSingleBoundAcknowledged,
  orderEligibilities: orderEligibilitiesForSingleBoundsAcknowledgedChangeAllowed
};

export const orderWithBothBoundsAcknowledged: MockOrder = {
  ...orderWithBothBoundsDisrupted,
  air: createOrderAirItem({
    template: {
      prices: multiCurrencyAirPricingRecordsForTwoBoundFlight,
      bounds: [cphOslAcknowledgedBound, oslCphAcknowledgedBound],
      freeCheckedBaggageAllowanceItems: cplOshReturnBaggageAllowanceItems,
      fareInfos: [{
        fareClass: 'JIFE',
        flightIds: [cphOslFlightItem.id, oslCphFlightItem.id],
        travelerIds: [traveler.id]
      }]
    }
  }),
  orderEligibilities: orderEligibilitiesForBothBoundsAcknowledged
};

export const acknowledge: AcknowledgeRequest = {
  lastName: traveler.names?.[0].lastName,
  airBoundIds: [boundId1]
};

export const acknowledgeForMultipleBounds: AcknowledgeRequest = {
  lastName: traveler.names?.[0].lastName,
  airBoundIds: [boundId1, boundId2]
};
export const orderMockEligibleToRefund: MockOrder = createOrder({
  template: orderEligibleToRefundTemplate
});

export const orderMockNotEligibleToRefund: Order = {
  ...orderMockEligibleToRefund,
  air: undefined,
  travelDocuments: undefined,
  paymentRecords: undefined,
  remarks: [
    {
      id: 'OT48',
      remarkType: 'GeneralRemark'
    },
    {
      id: 'OT50',
      remarkType: 'GeneralRemark'
    },
    {
      id: 'OT49',
      remarkType: 'GeneralRemark'
    }
  ]
};

export const orderWithScheduleChange: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslScheduleChangeBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForBoundWithScheduleChange
};

export const orderWithRoundTripOneBoundScheduleChange: MockOrder = {
  ...orderWithBothBoundsDisrupted,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslScheduleChangeBound, oslCphNonDisruptedBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForRoundTripOneBoundWithScheduleChange
};

export const orderWithRoundTripBothBoundScheduleChange: MockOrder = {
  ...orderWithBothBoundsDisrupted,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslScheduleChangeBound, oslCphScheduleChangeBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForRoundTripBothBoundWithScheduleChange
};

export const orderWithOpenJawBothBoundDisrupted: MockOrder = {
  ...orderWithReturnBoundDisrupted,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslBound, oslLhrBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForTwoBoundDisruption
};

export const orderWithOneStop: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [cphLhrOslBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForBoundWithScheduleChange
};

export const orderWithOneStopScheduleChange: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [cphLhrOslBoundScheduleChange]
    }
  }),
  orderEligibilities: orderEligibilitiesForBoundWithScheduleChange
};

export const orderWithInvolutaryRefundEligibleOneWayDisruptedUsingAmop: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslBoundInvoluntaryRefundEligible]
    }
  }),
  orderEligibilities: orderEligibilitiesForBoundWithInvolutaryRefundEligibleUsingAmop
};

export const orderWithInvolutaryRefundEligibleRoundTripDisruptedUsingCard: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslBoundInvoluntaryRefundEligible, oslCphNonDisruptedBound]
    }
  }),
  contacts: contactsForOneTraveler,
  orderEligibilities: orderEligibilitiesForRoundTripOneBoundDisrupted,
  paymentRecords: [{
    flightIds: [cphOslFlightItem.id],
    id: 'FPT19',
    paymentTransactions: [{
      amount: createAmount({
        template: {
          value: 65_948
        }
      }),
      paymentMethod: paymentCard,
      authorization: {
        approvalCode: 'APS1OK'
      }
    }],
    travelerIds: [traveler.id]
  },
  {
    id: 'FPT20',
    paymentTransactions: [{
      amount: createAmount({
        template: {
          value: 52_638
        }
      }),
      paymentMethod: paymentCard,
      authorization: {
        approvalCode: 'APS1OK'
      }
    }
    ],
    travelerIds: [traveler2.id],
    flightIds: [oslCphFlightItem.id]
  }],
  specialServiceRequests: [{
    id: 'OT3',
    code: 'CHLD',
    airlineCode: 'AY',
    statusCode: 'HK',
    quantity: 1,
    freetext: '05APR16',
    travelerIds: [traveler2.id]
  }],
  travelDocuments: [{
    flightIds: [cphOslFlightItem.id, oslCphFlightItem.id],
    travelerIds: [traveler.id],
    id: '1052467303580',
    documentType: 'eticket',
    price: {
      ...zeroPriceWithTaxes,
      base: 48_400,
      currencyCode: 'INR',
      taxes: multipleTaxesForCard,
      total: 65_948,
      totalTaxes: 17_548
    },
    paymentTransactions: [{
      paymentMethod: paymentCard
    }],
    fareInfos: [fareInfo]
  },
  {
    flightIds: [cphOslFlightItem.id, oslCphFlightItem.id],
    travelerIds: [traveler2.id],
    id: '1052467303581',
    documentType: 'eticket',
    price: {
      ...zeroPriceWithTaxes,
      base: 36_300,
      currencyCode: 'INR',
      taxes: multipleTaxesForCard2,
      total: 56_328,
      totalTaxes: 16_338
    },
    paymentTransactions: [{
      paymentMethod: paymentCard
    }],
    fareInfos: [fareInfo]
  }],
  travelers: [traveler, traveler2]
};

export const orderWithMilesTemplate: RecursivePartial<Order> = {
  ...orderEligibleToRefundTemplate,
  air: {
    prices: mockMilesAirPrice,
    bounds: [arnEwrBound],
    freeCheckedBaggageAllowanceItems: arnEwrBaggageAllowanceItems
  },
  travelers: [traveler],
  frequentFlyerCards: [frequentFlyerCard, frequentFlyerCard2],
  contacts: contactsForOneTraveler,
  travelDocuments: travelerDocumentsForMilesRefund,
  paymentRecords: [{
    id: 'FPT19',
    paymentTransactions: travelerDocumentsForMilesRefund[0].paymentTransactions!,
    travelerIds: [traveler.id],
    flightIds: [arnEwrFlightItem.id]
  }]
};
export const mockOrderWithMiles = createOrder({
  template: orderWithMilesTemplate
});

export const orderWithMilesWithoutCancellationTemplate: RecursivePartial<Order> = {
  ...orderEligibleToRefundTemplate,
  air: {
    prices: mockMilesAirPriceWithoutCancellation,
    bounds: [arnEwrBound],
    freeCheckedBaggageAllowanceItems: arnEwrBaggageAllowanceItems
  },
  services: serviceItem,
  travelers: [traveler],
  frequentFlyerCards: [frequentFlyerCard],
  contacts: contactsForOneTraveler,
  travelDocuments: travelerDocumentsForMilesRefundWithoutCancellation,
  paymentRecords: [{
    id: 'FPT19',
    paymentTransactions: milesPaymentTransactionsWithoutCancellation,
    travelerIds: [traveler.id],
    flightIds: [arnEwrFlightItem.id]
  },
  {
    id: 'FPT20',
    paymentTransactions: milesPaymentTransactionsWithoutCancellation,
    serviceItemIds: ['TSM24']
  }],
  orderEligibilities: milesRefundOrderEligibilities
};
export const mockOrderWithMilesWithoutCancellation = createOrder({
  template: orderWithMilesWithoutCancellationTemplate
});

export const mockOrderWithMilesForTwoPax: MockOrder = {
  ...mockOrderWithMiles,
  air: {
    bounds: [arnEwrBound],
    prices: mockMilesAirPriceForTwoPassengers,
    freeCheckedBaggageAllowanceItems: arnEwrBaggageAllowanceItemsForTwoPax
  },
  travelers: [traveler, traveler2],
  contacts: contactsForTwoTravelers,
  travelDocuments: travelerDocumentsForMilesRefundWithTwoPax,
  paymentRecords: [
    {
      id: 'FPT19',
      paymentTransactions: travelerDocumentsForMilesRefundWithTwoPax[0].paymentTransactions!,
      travelerIds: [traveler.id],
      flightIds: [arnEwrFlightItem.id]
    },
    {
      id: 'FPT20',
      paymentTransactions: travelerDocumentsForMilesRefundWithTwoPax[1].paymentTransactions!,
      travelerIds: [traveler2.id],
      flightIds: [arnEwrFlightItem.id]
    }
  ]
};

export const orderWithOneBoundSisterCity: MockOrder = {
  ...orderForUnOneWayOnly,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForSingleBoundSisterCity
};

export const orderWithRoundTripSisterCity: MockOrder = {
  ...orderWithBothBoundsDisrupted,
  air: createOrderAirItem({
    template: {
      bounds: [cphOslBound, oslCphBound]
    }
  }),
  orderEligibilities: orderEligibilitiesForSisterCityTwoBounds
};
